import React, { useEffect, useState } from 'react';
import './AdvertisingHead.css';
import { useDashboardData } from '../../../Context/DashboardContext/dashboardContext';
import arrowRight from '../../../Assets/Images/Active-Navigator-Right 15 x 15.png';
import { useNavigate } from "react-router-dom";
import { formatPrice } from '../../../Services/Api';


const AdvertisingHead = () => {
  const {adverstisementData} = useDashboardData();
  const navigate = useNavigate();
  const handleView = (url) => {
      navigate(url);
  };
  const username = sessionStorage.getItem('username')
  ?.split(/(?=[A-Z])/)
  .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
  .join(' ');
  const greetings = [
    {
      id:1,
      greet: "Welcome",
      isInspiration: true,
      message: `"Success is not the key to happiness. Happiness is the key to success. If you love what you are doing, you will be successful."`,
      url:""
    },
    {
      id:2,
      greet: "Hi",
      message: "Great to see you! Your store made $19000 sales yesterday. Let's aim even higher today!",
      url:"/Analytics/Revenue"
    },
    {
      id:3,
      greet: "Hello",
      message: "Your store is running smoother than butter on toast. Let’s make today amazing!",
      url:""
    },
    {
      id:4,
      greet: "Hey",
      message: "Did you know? It’s been [X] days since your store performance is above [x%] empowering shoppers. Keep up the fantastic work!",
      url:"/Performance/In-Sight"
    },
    {
      id:5,
      greet: "Happy Labor Day Sale, ",
      message: "Let’s make this Season unforgettable for your customers.",
      url:""
    },
    {
      id:6,
      greet: "Good to see you, ",
      message: "You received [X] new orders this month. Check them out!",
      url:"/E-Commerce/All-Orders"
    },
    {
      id:7,
      greet: "Hello ",
      message: "Yesterday, your most viewed product was [Product Name]. Don’t forget to advertise more!",
      url:"/E-Commerce/Add-Product"
    }
  ];

  const [selectedGreeting, setSelectedGreeting] = useState(null);

  useEffect(() => {
    const randomIndex = Math.floor(Math.random() * greetings.length);
    setSelectedGreeting(greetings[randomIndex]);
  }, []);

  if (!selectedGreeting) return null;

  return (
    <div className='advertising-head-inner-container'>
      <p className='advertising-head-tag'>FURNITURE DEPOTS DASHBOARD</p>
      <p className='advertising-head-greet'>{selectedGreeting.greet} {username}!</p>
      <h3 className='advertising-head-main-heading italic'>
        {selectedGreeting.isInspiration && (
          <span style={{ fontWeight: 400 }}>
            Here's your daily dose of inspiration:{' '}
          </span>
        )}
        {
        selectedGreeting.id === 2 ?  
        `Great to see you! Your store made ${formatPrice(adverstisementData.monthlySale)} sales this month. Let's aim even higher today!`:
        selectedGreeting.id === 4 ? 
        `Did you know? It’s been 7 days since your store performance is above ${adverstisementData?.performance}% empowering shoppers. Keep up the fantastic work!`:
        selectedGreeting.id === 6 ? 
        `You received ${adverstisementData.monthlyOrders} new orders this month. Check them out!`:
        selectedGreeting.id === 7 ? 
        `Yesterday, your most viewed product was ${adverstisementData.productName}. Don’t forget to advertise more!"`:
        selectedGreeting.message
        }
      </h3>
     
     <div className='button_section_adv'>
     {
     selectedGreeting.id === 2 || selectedGreeting.id === 4 || selectedGreeting.id === 6 || selectedGreeting.id === 7 ?
     <button onClick={()=>{handleView(selectedGreeting.url)}} className='advertising-head-join-now-button'>
            {selectedGreeting.id === 2 ? "See Reports" : selectedGreeting.id === 4 ? "See Performance" : selectedGreeting.id === 6 ? "See All Orders" : selectedGreeting.id === 7 ? "See All Products":"" } 
            <span className='advertising-head-join-now-button-arrow'>
                <img src={arrowRight} alt='arrow right' />
            </span>
      </button>:null
      }
     </div>
    </div>
  );
};

export default AdvertisingHead;
